<template>
    <div>
        <div class="vocab-body" v-if="showReport">
            <table class="vocab-table">
                <thead>
                    <tr>
                        <th></th>
                        <th><span v-html="$t('1st_record')"></span></th>
                        <th><span v-html="$t('2nd_record')"></span></th>
                        <th><span v-html="$t('3rd_record')"></span></th>
                        <th>{{ $t('final_score') }}</th>
                        <th>{{ $t('status') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in finalData" :key="index">
                        <td>{{ item.word }}</td>
                        <td v-for="(points, pointIndex) in fillPoints(item.points, 3)" :key="pointIndex">
                            <div v-if="points != '-'" class="vr-stars-col">
                                <div v-for="i in 5" :key="i">
                                    <div class="vr-star-icon" :class="{ 'vr-star-active': i <= getStar(points) }">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <span v-else class="status0">n/a</span>
                        </td>
                        <td>
                            <div v-if="getHighestScore(item.points) != '-'" class="vr-stars-col">
                                <div v-for="i in 5" :key="i">
                                    <div class="vr-star-icon" :class="{ 'vr-star-active': i <= getStar(getHighestScore(item.points)) }">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <span v-else class="status0">n/a</span>
                        </td>
                        <td :class="getColorVocab(getHighestScore(item.points))">{{ $t(getWordStatus(item.points)) }}
                        </td>
                    </tr>
                    <tr class="summary-row">
                        <td class="summary-label-cell" colspan="4">{{ $t('words_overall_score') }}:</td>
                        <td>
                            <div class="vr-stars-col">
                                <div v-for="i in 5" :key="'w-'+i">
                                    <div class="vr-star-icon" :class="{ 'vr-star-active': i <= getStar(wordScore) }">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="summary-status" :class="getColorVocab(wordScore)">{{ $t(classifyVocab(wordScore)) }}</td>
                    </tr>
                    <tr class="summary-row">
                        <td class="summary-label-cell" colspan="4">{{ $t('sentence_overall_score') }}:</td>
                        <td>
                            <div class="vr-stars-col">
                                <div v-for="i in 5" :key="'s-'+i">
                                    <div class="vr-star-icon" :class="{ 'vr-star-active': i <= getStar(sentenceScore) }">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="summary-status" :class="getColorVocab(sentenceScore)">{{ $t(classifyVocab(sentenceScore)) }}</td>
                    </tr>
                    <tr class="summary-row">
                        <td class="summary-label-cell status0" colspan="4">{{ $t('overall_score') }}:</td>
                        <td>
                            <div class="vr-stars-col">
                                <div v-for="i in 5" :key="'o-'+i">
                                    <div class="vr-star-icon" :class="{ 'vr-star-active': i <= getStar(overallScore) }">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="summary-status" :class="getColorVocab(overallScore)">{{ $t(classifyVocab(overallScore)) }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="comment status1">
                <span class="status0">{{ $t('feedback_suggest') }}: </span>{{ $t(finalResult.comment) }}
            </div>
        </div>
        <div v-else>
            <div class="status0 p-5">{{ $t('vocab_session_no_record') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        vocabData: {
            type: Array,
            required: true,
        },
        isActive: {
            type: Boolean,
            require: true
        }
    },
    computed: {
        finalResult() {
            if (this.overallScore / this.maxPoint < 0.4) {
                return { color: 'status1', comment: 'vocab_session_comment_need_more_effort' };
            } else if (this.overallScore / this.maxPoint < 0.8) {
                return { color: 'status3', comment: 'vocab_session_comment_well_done' };
            } else {
                return { color: 'status4', comment: 'vocab_session_comment_outstanding' };
            }
        },
    },
    methods: {
        parseScore(value) {
            if (!value || value === "-") return 0;
            const num = parseFloat(value);
            return isNaN(num) ? 0 : num;
        },
        fillPoints(points, length) {
            if (!points || !Array.isArray(points)) {
                points = [];
            }
            return [...points, ...Array(length - points.length).fill('-')].slice(0, length);
        },
        getColorVocab(value) {
            if (value === '-') return '';
            const score = this.parseScore(value);
            if (isNaN(score) || score / this.maxPoint < 0.1) {
                return "status1";
            } else if (score / this.maxPoint < 0.4) {
                return "status1";
            } else if (score / this.maxPoint < 0.8) {
                return "status3";
            } else {
                return "status4";
            }
        },
        getStar(value) {
            if (value === '-') return 0;
            const score = this.parseScore(value);
            if (isNaN(score) || score / this.maxPoint < 0.1) {
                return 0;
            } else if (score / this.maxPoint < 0.4) {
                return 3;
            } else if (score / this.maxPoint < 0.8) {
                return 4;
            } else {
                return 5;
            }
        },
        getHighestScore(items) {
            if (!items || !items.length) return '-';
            let highestScore = 0;
            for (const item of items) {
                const score = this.parseScore(item);
                if (score > highestScore) {
                    highestScore = score;
                }
            }
            return highestScore;
        },
        getWordStatus(items) {
            return this.classifyVocab(this.getHighestScore(items));
        },
        classifyVocab(score) {
            if (score === '-') return '';
            if (isNaN(score) || score / this.maxPoint < 0.1) {
                return "voice_not_recognized";
            }  else if (score / this.maxPoint < 0.4) {
                return "need_more_effort";
            } else if (score / this.maxPoint < 0.8) {
                return "well_done";
            } else {
                return "outstanding";
            }
        },
    },
    mounted() {
        if (this.vocabData && this.vocabData.length && this.isActive) {
            let wscore = 0, sscore = 0, hasRecorded = false;
            for (const item of this.vocabData) {
                for (const item1 of item.wordVocab) {
                    this.finalData.push({
                        word: item1.type == 2 ? this.$t('example_of') + ' ' + item.word : item.word,
                        points: item1.points
                    });
                    if (!item1.points || !item1.points.length) continue;
                    hasRecorded = true;
                    if (item1.type == 1) {
                        wscore += this.getHighestScore(item1.points);
                    }
                    else {
                        sscore += this.getHighestScore(item1.points);
                    }
                }
            }
            this.overallScore = (wscore + sscore) / (this.vocabData.length * 2);
            this.wordScore = wscore / this.vocabData.length;
            this.sentenceScore = sscore / this.vocabData.length;
            this.showReport = hasRecorded;
        }
    },
    data() {
        return {
            showReport: false,
            overallScore: 0,
            wordScore: 0,
            sentenceScore: 0,
            finalData: [],
            maxPoint: 100
        };
    },
};
</script>

<style scoped>
.vocab-body {
    margin: 20px 77px;
}

.vocab-table {
    margin: 0 auto;
    border-collapse: collapse;
    background: #fff;
    color: #000;
    width: 100%;
}

.vocab-table th:first-child,
.vocab-table td:first-child {
    width: 250px;
    text-align: left;
}

.vocab-table th:nth-child(2),
.vocab-table th:nth-child(3),
.vocab-table th:nth-child(4),
.vocab-table th:nth-child(5),
.vocab-table td:nth-child(2),
.vocab-table td:nth-child(3),
.vocab-table td:nth-child(4),
.vocab-table td:nth-child(5) {
    min-width: 110px;
}

.vocab-table th:last-child,
.vocab-table td:last-child {
    white-space: nowrap;
    width: 1%;
}

.vocab-table th,
.vocab-table td {
    border: 1px solid #2F66C9;
    padding: 8px;
    text-align: left;
    font-size: 14px;
    background-color: #fff;
}

.hidden-td {
    border-bottom: none !important;
    border-left: none !important;
}

.status0 {
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
}

.status1 {
    color: #FF0000;
    font-weight: bold;
}

.status2 {
    color: #7158C2;
    font-weight: bold;
}

.status3 {
    color: #FFA800;
    font-weight: bold;
}

.status4 {
    color: #28A745;
    font-weight: bold;
}

.comment {
    font-size: 14px;
    font-weight: bold;
    margin-top: 20px;
    text-align: center;
}

.vocab-table td.summary-label-cell {
    text-align: right;
    padding-right: 8px;
}

.summary-status {
    font-weight: bold;
    white-space: nowrap;
    font-size: 14px;
}

.vocab-table tr.summary-row td {
    border: none;
    padding-bottom: 1px;
}

.vr-stars-col {
    display: flex;
    align-items: center;
}

.vr-star-icon {
    width: 1.25rem;
    height: 1.25rem;
    color: #D8D8D8;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.vr-star-icon>svg {
    width: 100%;
    height: 100%;
    fill: currentColor !important;
    stroke: currentColor;
}

.vr-star-active {
    color: #F7C734 !important;
}
</style>